import { ResourceProvider } from './context'

export const Root = ({ children, ...rest }) => (
  <ResourceProvider {...rest}>{children}</ResourceProvider>
)
